import { useState, useMemo } from 'react';
import React from 'react'
import { Row, Col, Card, CardBody, CardHeader, Button, Collapse, Table, FormGroup, Label, Input } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import MapView from '../Map/MapView';
import uuid from 'react-uuid';
const AllFarmMap = ({ itemModel, totalFarmDetails }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [isIconUp, setIsIconUp] = useState(true); 
    const [mapDetails, setMapDetails] = useState({allVineyardSummaryPage:true,
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false, isAllFarmDetails: true,
        isFarmOutlineEditable: false, zoomLevel: 5, polytype: '', itemsEditable: false, highlighteditemId: 0, hideLabelAndPin:false
    });
    const toggle = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const handleZoomLevel = (zoomLevel) => {
        setMapDetails({ ...mapDetails, zoomLevel: zoomLevel });
    }
    /*Avoid unwanted page refresh*/
    const mapView = useMemo(() => {
        return (
            <MapView
                itemModel={itemModel} width={'100%'}
                mapDetails={mapDetails} handleZoomLevel={handleZoomLevel}
            ></MapView>
        )
    }, [itemModel, mapDetails])

    return (
        <div>
            <Row style={{ marginTop: `15px` }}>
                <Col>
                    <Card>
                        <CardHeader className="item-header item_click" onClick={toggle}>
                            <Row>
                                <Col sm="11">
                                    <h6>Boundary Summary
                                       
                                    </h6>
                                </Col>
                                <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Collapse isOpen={isOpen}>
                                <div> 
                                    <Row>

                                        <Table striped bordered hover style={{ tableLayout: 'fixed', width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th># Total Vineyards</th>
                                                    <th>Total HA</th>
                                                    <th>Total KM perimeter</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr key={uuid()}>
                                                    <td>{totalFarmDetails.totalFarms} </td>
                                                    <td>{totalFarmDetails.totalFarmArea.toFixed(2)}</td>
                                                    <td>{totalFarmDetails.totalFarmPerimeter.toFixed(2)}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Row>
                                    <Row>
                                        <Col id='mapView'>
                                            <Row className="map-layer">
                                                <Col>
                                                    <Row>
                                                        <Col sm="8"></Col>
                                                        <Col sm="4">
                                                            <div className="map-item-edit-div">
                                                                <Label className="map-checkbox-label">Hide Pins & Labels</Label>
                                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.hideLabelAndPin} onChange={(e) => setMapDetails({ ...mapDetails, hideLabelAndPin: !mapDetails.hideLabelAndPin })} name="hideLabelAndPin" id="hideLabelAndPin" />&nbsp;&nbsp;
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {mapView}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </Collapse>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
export default AllFarmMap;